import { UserUI } from '@src/models';
import { DECISION_TYPE_CODE } from '@src/constants';
import { _ } from '@ngx-translate/core';

import { GroupedListItem } from '../model/groups.model';
import { ItemType, ListTypes } from '../model/item.model';

export const getGroups = (items: ItemType[], listType: ListTypes) => {
  const groups: GroupedListItem[] = [];

  if (listType === 'users') {
    const itemsTyping = items as UserUI[];

    groups.push({
      title: _('components.list.constants.decisionTypeCode.accepted'),
      items: itemsTyping.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Accepted),
    });

    groups.push({
      title: _('components.list.constants.decisionTypeCode.passed'),
      items: itemsTyping.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Passed),
    });

    groups.push({
      title: _('components.list.constants.decisionTypeCode.readed'),
      items: itemsTyping.filter(
        item =>
          item.decisionTypeCode === DECISION_TYPE_CODE.Sended || item.decisionTypeCode === DECISION_TYPE_CODE.Readed,
      ),
    });

    groups.push({
      title: _('components.list.constants.decisionTypeCode.rejected'),
      items: itemsTyping.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Rejected),
    });
  }

  return groups;
};
